import { Helmet } from 'react-helmet';
import { useState } from 'react';
import * as S from './Careers.styles';

const Careers = () => {
  const [copied, setCopied] = useState(false);
  const email = 'michael.k@uplusedu.com.au';

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // 2秒后重置状态
    } catch (err) {
      console.error('Failed to copy email:', err);
      // 降级方案：手动选择文本
      const textArea = document.createElement('textarea');
      textArea.value = email;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <S.Container>
      <Helmet>
        <title>Join Our Team - Uplus Education</title>
        <meta name="description" content="Join our team of passionate educators at Uplus Education" />
      </Helmet>
      
      <S.Title>Join Us</S.Title>
      
      <S.Content>
        <S.Description>
          We are always on the lookout for passionate, dedicated, and professional 
          educators to join our growing team.
        </S.Description>
        <S.Description>
          Due to increasing student demand, we are expanding and looking for experienced teachers to join us.
        </S.Description>
        <S.RequirementsSection>
          <S.SectionTitle>Application Requirements</S.SectionTitle>
          <S.Paragraph>
            If you're interested in becoming part of our teaching team, please send us the following documents:
          </S.Paragraph>
          
          <S.RequirementsList>
            <S.RequirementItem>
              <S.BulletPoint>•</S.BulletPoint>
              A copy of your CV
            </S.RequirementItem>
            <S.RequirementItem>
              <S.BulletPoint>•</S.BulletPoint>
              At least one reference letter
            </S.RequirementItem>
            <S.RequirementItem>
              <S.BulletPoint>•</S.BulletPoint>
              Your availability (days and times you are able to work)
            </S.RequirementItem>
          </S.RequirementsList>
        </S.RequirementsSection>
        
        <S.ContactSection>
          <S.EmailLabel>Please email your application to:</S.EmailLabel>
          <S.EmailContainer>
            <S.EmailLink href={`mailto:${email}`}>
              {email}
            </S.EmailLink>
            <S.CopyButton onClick={handleCopyEmail} copied={copied}>
              <S.CopyIcon copied={copied}>
                {copied ? '✓' : '📋'}
              </S.CopyIcon>
              <S.CopyText>{copied ? 'Copied!' : 'Copy'}</S.CopyText>
            </S.CopyButton>
          </S.EmailContainer>
        </S.ContactSection>
        
        <S.ClosingText>
          We look forward to hearing from you!
        </S.ClosingText>
      </S.Content>
    </S.Container>
  );
};

export default Careers;